import Checkbox from '@/common/components/Checkbox'
import TextField from '@/common/components/TextField'

export type BranchInformationProps = {
  displayName?: string
  parentId?: string
  parentDisplayName?: string
  shouldHaveOwnBillWhenDynamic?: boolean
  billBy?: string
}

export const BranchInformation = ({
  displayName,
  parentId,
  parentDisplayName,
  shouldHaveOwnBillWhenDynamic,
  billBy,
}: BranchInformationProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2 w-full justify-between">
        <TextField label="Nome da filial" name="display_name" value={displayName} className="w-full" disabled />
        {parentId && (
          <TextField
            label="Filial Mãe"
            className="w-full"
            name="parent"
            value={parentDisplayName}
            disabled
          />
        )}
      </div>

      {billBy === 'dynamic_branch' && (
        <Checkbox label="Possui faturamento próprio" checked={shouldHaveOwnBillWhenDynamic} disabled />
      )}
    </div>
  )
}
